import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";

function CompareChanges({ before, after }) {
  const { t } = useTranslation();
  const [changes, setChanges] = useState(null);

  const reservationZone = useSelector((state) => state.reservationZone);
  const { zones, isZonesLoading, zonesError } = reservationZone;

  const fieldsToShow = [
    "full_name",
    "phone_number",
    "date",
    "time",
    "number_of_people",
    "message",
    "table_place_preference",
  ];
  const calculateChanges = (current, previous) => {
    const changes = {};
    fieldsToShow.forEach((key) => {
      if (key === "table_place_preference") {
        const currentPlaceId = current[key]?.id; // Use optional chaining
        const previousPlaceId = previous[key]; // Assuming previous directly stores the id

        // Use optional chaining and provide fallback values
        const currentPlaceName =
          zones?.zones_with_id?.[currentPlaceId] ?? t("ui.components.compareChanges.unknownPlace");
        const previousPlaceName =
          zones?.zones_with_id?.[previousPlaceId] ?? t("ui.components.compareChanges.unknownPlace");

        if (currentPlaceName !== previousPlaceName) {
          changes[key] = {
            from: previousPlaceName,
            to: currentPlaceName,
          };
        }
      } else {
        if (current[key] !== previous[key]) {
          changes[key] = {
            from: previous[key],
            to: current[key],
          };
        }
      }
    });
    return changes;
  };
  const renderValue = (value) => {
    if (typeof value === "object" && value !== null) {
      if (value.place_of_table) {
        return JSON.stringify(value.place_of_table);
      }
      // Here you can customize how you want to display the object
      // For example, displaying keys and values or just converting it to a string
      return JSON.stringify(value);
    }
    return value;
  };

  const codeToText = (value) => {
    if (value === true) {
      return t("ui.components.compareChanges.yes");
    } else if (value === false) {
      return t("ui.components.compareChanges.no");
    } else if (value === "pending_customer") {
      return t("ui.components.compareChanges.reservationInProgress");
    } else if (value === "Pending_from_Restaurant") {
      return t("ui.components.compareChanges.pendingAcceptance");
    } else if (value === "edited") {
      return t("ui.components.compareChanges.editedByCustomer");
    } else if (value === "Waiting_List") {
      return t("ui.components.compareChanges.waitingList");
    } else if (value === "accepted") {
      return t("ui.components.compareChanges.acceptedWithoutTable");
    } else if (value === "Accepted_Without_Table") {
      return t("ui.components.compareChanges.acceptedWithoutTable");
    } else if (value === "Accepted_With_Table") {
      return t("ui.components.compareChanges.acceptedWithTable");
    } else if (value === "attended") {
      return t("ui.components.compareChanges.completed");
    } else if (value === "no_show") {
      return t("ui.components.compareChanges.noShow");
    } else if (value === "cancelled_customer") {
      return t("ui.components.compareChanges.cancelledByCustomer");
    } else if (value === "Cancelled_cancelled_restaurantBy_Restaurant") {
      return t("ui.components.compareChanges.cancelledByRestaurant");
    } else if (value === "time") {
      return t("ui.components.compareChanges.time");
    } else if (value === "number_of_people") {
      return t("ui.components.compareChanges.peopleCount");
    } else if (value === "table_place_preference") {
      return t("ui.components.compareChanges.space");
    } else if (value === "full_name") {
      return t("ui.components.compareChanges.name");
    } else if (value === "date") {
      return t("ui.components.compareChanges.date");
    } else if (value === "message") {
      return t("ui.components.compareChanges.message");
    } else if (value === "phone_number") {
      return t("ui.components.compareChanges.phone");
    }
    return value;
  };

  useEffect(() => {
    if (before && after) {
      setChanges(calculateChanges(after, before));
    }
  }, [before, after]);

  return (
    <div>
      {changes ? (
        Object.keys(changes).map((key) => (
          <div
            key={key}
            style={{
              color: "black",
              fontSize: "14px",
              display: "flex",
              flexWrap: "wrap",
            }}
          >
            {codeToText(key) + ": "}
            <div style={{ color: "red", fontSize: "14px" }}>
              {" "}
              {renderValue(codeToText(changes[key].from))}{" "}
            </div>{" "}
            →
            <div style={{ color: "green", fontSize: "14px" }}>
              {" "}
              {renderValue(codeToText(changes[key].to))}{" "}
            </div>
          </div>
        ))
      ) : (
        <></>
      )}
    </div>
  );
}

export default CompareChanges;
